// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1xZuz","row":"styles_row__1GKE7"};